import { useQuery } from '@apollo/client';
import {
  NotificationListFilterInput,
  NotificationListSortingInput,
  NotificationsDocument,
  NotificationsQuery,
} from 'src/graphql/generated/graphql';

const DEFAULT_PAGINATION_LIMIT = 10;
const DEFAULT_PAGE = 0;
export const useNotifications = ({
  filter,
  page,
  pageLimit,
  sorting,
  skip,
  onCompleted,
}: {
  filter: NotificationListFilterInput;
  page?: number;
  pageLimit?: number;
  sorting?: NotificationListSortingInput;
  skip?: boolean;
  onCompleted?: ((data: NotificationsQuery) => void) | undefined;
}) => {
  const limit = pageLimit || DEFAULT_PAGINATION_LIMIT;
  const offset = (page || DEFAULT_PAGE) * limit;
  const { data, loading } = useQuery<NotificationsQuery>(
    NotificationsDocument,
    {
      variables: {
        filter,
        sorting,
        pagination: {
          limit,
          offset,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
      skip: skip,
      onCompleted: onCompleted,
    },
  );

  return {
    data: data?.notifications,
    loading,
  };
};
